<template>
  <div id="cc">
    <comp-menu/>
    <div :class="(windowWidth < 1024 ? 'container-fluid' : 'container') ">
      <router-view  />
    </div>
    <comp-sidebar />
  </div>
</template>

<script>
import CompMenu from "./components/CompMenu";
import CompSidebar from "./components/CompSidebar";

export default {
  name: "CC",
  components: {
    CompMenu,
    CompSidebar,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

